import { FunctionalComponent} from 'preact';
import Popover from '../Popover';
import styles from './styles.module.scss';
import { useState } from 'preact/hooks';

interface Props {
  amount: number;
  className?: string;
  onClose?: () => void;
}

const ShellsPopover: FunctionalComponent<Props> = ({
  amount,
  className,
}: Props) => {
  const [isDisplayed, setDisplayed] = useState(true);

  const handleClose = () => {
    setDisplayed(false);
  }

  if (!isDisplayed) return null;
  return (
    <div onAnimationEnd={handleClose} style={{ display: amount ? 'block' : 'none' }}>
      <Popover
        className={`${styles.shellsPopover} ${className}`}
        onClose={handleClose}
      >
        <div className={styles.contentWrapper}>
          {!!amount && <p className={styles.secondAnimation}>+{amount}</p>}

          <img src={`img/yellow-shell.svg`} width="19" height="21" alt="shell" />
        </div>
      </Popover>
    </div>
  );
};

export default ShellsPopover;
